import { ConvexQueryClient } from "@convex-dev/react-query";
import { QueryClient } from "@tanstack/react-query";
import { ConvexReactClient } from "convex/react";
import { CONVEX_URL } from "../env.client";

export const convex = new ConvexReactClient(CONVEX_URL!);
export const convexQueryClient = new ConvexQueryClient(convex);

export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      queryKeyHashFn: convexQueryClient.hashFn(),
      queryFn: convexQueryClient.queryFn(),
      // Reduce excessive refetching - data is considered fresh for 1 minute
      staleTime: 60 * 1000,
      // Keep unused data in cache for 5 minutes before garbage collection
      gcTime: 5 * 60 * 1000,
      // Disable automatic refetch on window focus to reduce function calls
      refetchOnWindowFocus: false,
    },
  },
});

convexQueryClient.connect(queryClient);
